// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nfY1","tabsBox":"styles_tabsBox__1fA0H","createButton":"styles_createButton__3lmI8"};